<footer *ngIf="isLearnerPage() && !appStateService.isPlayerMode()" class="lg:py-12 py-6 bg-brand-600 dark:bg-zinc-800 text-white" role="contentinfo" aria-label="Site footer" [ngClass]="{'w-max mr-0': userwaySettings.value.biggerText > 2}">
    <div class="container">
        <div class="grid sm:grid-cols-2 xl:grid-cols-4  gap-4">
            <div class="sm:col-span-2 lg:col-span-4">
                <img [src]="logoSrc" class="h-12 mb-4 xl:mb-10" alt="Youth4Jobs - Empowering youth through employment opportunities" aria-label="Youth4Jobs logo">
            </div>

            <div class="flex flex-col gap-4 xl:pr-12" role="region" aria-labelledby="contact-heading">
                <h2 id="contact-heading" class="sr-only">Contact Information</h2>
                <a href="tel:+91 9281 011895" class="flex gap-2 hover:text-brand-100 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-brand-600 rounded" aria-label="Call us at +91 9281 011895">
                    <i class="ti mt-1 ti-phone" aria-hidden="true"></i> 
                    <span>+91 9281 011895</span>
                </a>
                <a href="mailto:contact@youth4jobs.org" class="flex gap-2 hover:text-brand-100 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-brand-600 rounded" aria-label="Email us at contact@youth4jobs.org">
                    <i class="ti mt-1 ti-mail" aria-hidden="true"></i>
                    <span>contact&#64;youth4jobs.org</span>
                </a>
                <address class="flex gap-2 not-italic">
                    <i class="ti mt-1 ti-map" aria-hidden="true"></i>
                    <span>
                        Plot no: 4, 8-2-686/D/1/G/4, Kanchi Thatti Khana Road No. 12, Banjara Hills, Hyderabad, 500034, Telangana, India.
                    </span>
                </address>
            </div>

            @for (section of linkSections; track $index) {
            <div class="flex flex-col gap-4 xl:pr-12" role="region" [attr.aria-labelledby]="'section-' + $index">
                <h3 [id]="'section-' + $index" class="font-semibold text-[1.25rem]">{{ section.title }}</h3>
                <nav [attr.aria-label]="section.title + ' links'">
                    <div class="flex flex-col gap-2">
                        @for (item of section.links; track $index) {
                        <a [routerLink]="item.url" 
                           class="text-brand-100 hover:text-white focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-brand-600 rounded px-1 py-1"
                           [attr.aria-label]="'Navigate to ' + (item.label ? item.label : item.name)">{{ item.name }}</a>
                        }
                    </div>
                </nav>
            </div>
            }
            <div class="sm:col-span-2 lg:col-span-4 h-px bg-brand-500 dark:bg-zinc-600 my-4" aria-hidden="true"></div>

            <div class="sm:col-span-2 lg:col-span-4">
                <div class="flex flex-wrap gap-4">
                    <div class="social-icons flex gap-1 flex-1" role="region" aria-labelledby="social-heading">
                        <h2 id="social-heading" class="sr-only">Social Media Links</h2>
                        <a class="flex items-center justify-center w-8 h-8 rounded bg-brand-700/30 hover:bg-brand-700/60 dark:bg-zinc-700/50 dark:hover:bg-zinc-600 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-brand-600"
                            *ngFor="let social of socialLinks; let i = index" 
                            [href]="social.url" 
                            target="_blank"
                            rel="noopener noreferrer"
                            [attr.aria-label]="'Follow us on ' + getSocialPlatformName(social.icon)">
                            <i [class]="social.icon" aria-hidden="true"></i>
                        </a>
                    </div>
                    <div class="flex-1 text-center" role="contentinfo">{{ copyright }}</div>
                    <div class="flex-1 text-right">
                        <a class="text-brand-100 hover:text-white focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-brand-600 rounded px-1 py-1"
                           [routerLink]="privacyPolicy"
                           aria-label="Read our Privacy Policy">Privacy Policy</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</footer>